import React from 'react';
import { useState } from "react";

import { signInAnonymously } from "firebase/auth";
import { linkWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../context/Firebase.jsx';
import { useAuth } from '../../context/AuthContext.jsx';
import { useApp } from '../../context/AppContext.jsx';
import { useSave } from '../../context/SaveContext.jsx';

import { useTranslation } from "react-i18next";
import { MyButton, MyDangerButton } from "../../component/ui/UI.jsx";

export const AccountPage = () =>
{
	const { t } = useTranslation();
	const {user, login, logout, deleteUser} = useAuth();
	const {setYesNoModal} = useApp();
	const {deleteStore, deleteLocal, clearSave} = useSave();

	const onClickLoginAnonymously = () => {
		(async() => {
			const userCredential = await signInAnonymously(auth);
			console.log("Anonymous user:", userCredential.user.uid);
		})();
	};

	const upgradeToGoogle = () => {
		(async() => {
			const user = auth.currentUser;
			if (!user) {
				console.error("No current anonymous user.");
				return;
			}
			try {
				const result = await linkWithPopup(user, googleProvider);
				console.log("Account upgraded!", result.user.uid);
			} catch (error) {
				console.error("Link error:", error);
			}
		})();
	};

	const onLoginWithGoogle = async () => {
		await login();
	};

	const onLogout = async () => {
		await logout();
		deleteLocal();
		clearSave();
	};

	return (
		<div className="d-flex flex-column p-1 gap-1">
			{user && (
			<div className="card p-1">
				<ul className="list-unstyled m-0">
					{/*<li>{user ? user.uid : "None"}</li>*/}
					<li>{user ? user.displayName : "None"}</li>
					{/*<li>{user ? user.email : "None"}</li>*/}
				</ul>
			</div>
			)}
			{!user && (
				<div className="d-flex align-items-start gap-2">
					<MyButton onClick={() => {onLoginWithGoogle()}} text={t("LoginGoogle")} />
				</div>
			)}
			{user && (
				<div className="d-flex align-items-start gap-2">
					<MyButton onClick={() => {onLogout()}} text={t("Common_Logout")} />
				</div>
			)}
			{user && (
				<div className="d-flex align-items-start gap-2">
					<MyDangerButton
						onClick={() => {
							setYesNoModal({
								title: t("Common_DeleteSave"),
								onClose: ()=>{setYesNoModal(null)},
								onSubmit: async  ()=>{
									await deleteStore();
									deleteLocal();
									clearSave();
								},
								body: <div>{t("DeleteSaveAsk")}</div>
							});
						}}
						text={t("Common_DeleteSave")}
					/>
				</div>
			)}
			{user && (
				<div className="d-flex align-items-start gap-2">
					<MyDangerButton
						onClick={() => {
							setYesNoModal({
								title: t("Common_DeleteAccount"),
								onClose: ()=>{setYesNoModal(null)},
								onSubmit: async ()=>{
									await deleteStore();
									deleteLocal();
									clearSave();
									await deleteUser();
								},
								body: <div>{t("DeleteAccountAsk")}</div>
							});
						}}
						text={t("Common_DeleteAccount")}
					/>
				</div>
			)}
		</div>
	);
};
